import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=33f8dcee&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33f8dcee')) {
      api.createRecord('33f8dcee', component.options)
    } else {
      api.reload('33f8dcee', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=33f8dcee&", function () {
      api.rerender('33f8dcee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/layout/Footer.vue"
export default component.exports